"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.anti-hallucination.disabled': 'La funzione anti-allucinazione non è disponibile nel tuo piano attuale.',
};
